<template>
<div class="chapter">
<div class="inner_page">
<p class="h1">Introduction</p>
<p class="noindent">This story highlights the best moments, players and media members in Cleveland Cavaliers history. It has in-depth, extremely personal interviews with some of the top names in the history of the organization. It is a no-holds-barred account of the most intimate and sometimes controversial details of the most impactful moments in Cavaliers history. This book has input from the players mixed in with the media who covered the Cavs and the fans who watched them. This book will change the way the entire sports nation looks at Cleveland. Finally, the true stories are told!</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// intro.vue?4aa2936a